export class DropdownOptionResponse<T> {
  id: T
  active: boolean
  name: string

  highlighted: boolean

  constructor(id: T, active: boolean, name: string) {
    this.id = id
    this.active = active
    this.name = name

    this.highlighted = false
  }
}
